import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import Overview from "./Overview";
import Footer from "./Footer";
import reportWebVitals from "./reportWebVitals";

const defaultCity = process.env.REACT_APP_DEFAULT_CITY;
const geolocationApiKey = process.env.REACT_APP_GEOLOCATION_API_KEY;
const cache_expiration = 10 * 60 * 1000;

const cache = {};

const App = () => {
  const [city, setCity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCityFromCoordinates = async (latitude, longitude) => {
      const cacheKey = `${latitude},${longitude}`;
      const now = Date.now();

      if (
        cache[cacheKey] &&
        now - cache[cacheKey].timestamp < cache_expiration
      ) {
        setCity(cache[cacheKey].city);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `https://api.opencagedata.com/geocode/v1/json`,
          {
            params: {
              q: `${latitude},${longitude}`,
              key: geolocationApiKey,
            },
          }
        );
        const results = response.data.results;
        if (results && results.length > 0) {
          const city =
            results[0].components.city ||
            results[0].components.town ||
            results[0].components.village ||
            defaultCity;

          cache[cacheKey] = { city, timestamp: Date.now() };

          setCity(city);
        } else {
          setCity(defaultCity);
        }
      } catch (error) {
        console.error("Error fetching city name:", error);
        setError("Failed to fetch city name. Please try again later.");

        setCity(defaultCity);
      } finally {
        setLoading(false);
      }
    };

    const getUserLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            fetchCityFromCoordinates(latitude, longitude);
          },
          (error) => {
            console.error("Error getting geolocation:", error);
            setCity(defaultCity);
            setLoading(false);
          }
        );
      } else {
        setCity(defaultCity);
        setLoading(false);
      }
    };

    getUserLocation();
  }, []);

  if (loading) {
    return <div className="loading">Finding your current location...</div>;
  }

  if (error) {
    return <div className="loading">{error}</div>;
  }

  return (
    city && (
      <React.StrictMode>
        <main className="p-3">
          <Overview defaultCity={city} />
        </main>
        <Footer />
      </React.StrictMode>
    )
  );
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

reportWebVitals();
